{
  "name": "app-pacs",
  "version": "0.0.1-alpha.48",
  "license": "SEE LICENSE IN LICENSE.md",
  "description": "L'application PACS",
  "main": "dist/js/index.js",
  "module": "dist/es/index.js",
  "scripts": {
    "lint": "biome check .",
    "lint:fix": "biome check --write .",
    "test": "vitest",
    "test:unit": "vitest run",
    "start": "NODE_ENV=development vite dev",
    "build": "NODE_OPTIONS='--max-old-space-size=8096' vite build",
    "build:app": "NODE_OPTIONS='--max-old-space-size=8096' vite build"
  },
  "dependencies": {
    "@mairistem/administres-utils": "1.7.5",
    "@mairistem/adresses": "^0.7.13",
    "@mairistem/composants": "^0.9.2",
    "@mairistem/entites": "0.2.1",
    "@mairistem/fiche": "^0.11.9",
    "@mairistem/liste": "^0.11.4",
    "@mairistem/module": "^0.10.8",
    "@mairistem/tools": "^0.4.10",
    "@sentry/react": "^10.78.0",
    "dayjs": "^1.11.23",
    "lodash": "^4.18.1",
    "lucide-react": "^1.64.0",
    "pdfjs-dist": "^5.7.284",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-router": "5.3.4",
    "react-router-dom": "5.3.4",
    "react-toastify": "^11.2.0",
    "recharts": "^3.10.1",
    "rsuite": "^6.2.5",
    "rsuite-table": "^5.19.3",
    "start": "^5.1.0",
    "zustand": "^5.0.16"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.6.4",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.8",
    "@types/lodash": "^4.17.27",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "buffer": "^6.0.3",
    "crypto-browserify": "^3.12.1",
    "csstype": "^3.2.3",
    "esbuild": "^0.28.2",
    "happy-dom": "^21.0.4",
    "less": "^4.9.1",
    "stream-browserify": "^3.0.0",
    "typescript": "^6.0.3",
    "vite": "^8.3.5",
    "vitest": "^5.0.5"
  }
}
